export { default as dataLayer } from './data-layer';
export { default as amplitude } from './amplitude';
export { default as hotjar } from './hotjar';
export { default as optimizely } from './optimizely';
export { default as CONSTANTS } from './constants';

import googleAnalyticsLog from './google';
export default function log(category, action, callback = () => {}) {
  googleAnalyticsLog(category, action, callback);
}
